import {
  getReq,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'

const actions = {
  async findSysVersionByApplicationType({
    commit,
    state
  }, {codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_SYS_VERSION_BY_APPLICATION_TYPE + `?versionNo=${state.versionNo}`, {headerCodeMap: await getHeaderCodeMap(codeParam)})
    return responseData
  },
  async getGlobalCompIdDDList({
    commit,
    state
  }, {codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_SYS_COMPANY_DD_LIST, {headerCodeMap: await getHeaderCodeMap(codeParam)})
    if (responseData.code === 2000) {
      commit('updateGlobalCompIdDDList', responseData.data)
    } else {
      commit('updateGlobalCompIdDDList', [])
    }
  },
  async findProjSettleDtNumDDList({
    commit,
    state
  }) {
    const responseData = await getReq(END_POINTS.FIND_PROJ_SETTLE_DT_NUM_DD_LIST, {})
    if (responseData.code === 2000) {
      commit('updateProjSettleDtNumList', responseData.data)
    } else {
      commit('updateProjSettleDtNumList', [])
    }
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js